import { defineStore } from 'pinia';
import Pusher from "pusher-js";

const pusherKey = `${process.env.VUE_APP_PUSHER_KEY}`;
const pusherCluster = `${process.env.VUE_APP_PUSHER_CLUSTER}`;

export const usePusherStore = defineStore({
    id: 'pusher',
    state: () => ({
        channel: null,
    }),
    actions: {
        reset() {
            this.channel = null;
        },

        async subscribeToChannel(channelName) {
            const pusher = new Pusher(pusherKey, {
                cluster: pusherCluster,
            });
            this.channel = pusher.subscribe(channelName);
            console.log('pusher has been connected');
        },
    },
});
